import { buildBindable } from '@monofe/di';
import type { IMessageInstantiator } from '../../message/interface/instantiator';
import {
    bindMessageInstantiator,
    injectMessageInstantiator,
    TYPES,
    unbindMessageInstantiator,
} from '../../message/interface/instantiator';
import instantiator from './instantiator';

export default buildBindable<IMessageInstantiator>({
    id: TYPES.IMessageInstantiator,
    bind: bindMessageInstantiator,
    remove: unbindMessageInstantiator,
    inject: injectMessageInstantiator,
    build: () => Promise.resolve(instantiator),
});
